import { useEffect } from 'react';
import { UseToastOptions } from '@chakra-ui/react';

import { useShowMessage } from '../../core-ui';
import { EventEmitter } from '../../support/helpers/EventEmitter';

type ShowMessageObject = {
  type: UseToastOptions['status'];
  message: string;
};

type Events = {
  showMessage: [ShowMessageObject];
};

const eventEmitter = new EventEmitter<Events>();

export default function AppAlert() {
  let showMessage = useShowMessage();

  useEffect(() => {
    return eventEmitter.addListener('showMessage', (showMessageObject) => {
      showMessage(showMessageObject.type, showMessageObject.message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export function showSuccess(message: string) {
  eventEmitter.emit('showMessage', { type: 'success', message });
}

export function showError(message: string) {
  eventEmitter.emit('showMessage', { type: 'error', message });
}

export function showWarning(message: string) {
  eventEmitter.emit('showMessage', { type: 'warning', message });
}
